import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=906275ac&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=906275ac&prod&lang=scss&scoped=true"
import style1 from "./goods.vue?vue&type=style&index=1&id=906275ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906275ac",
  null
  
)

export default component.exports